import { range } from 'lodash-es';
import { memo } from 'react';
import MCSChartItem from 'modules/bottomPanel/containers/MCSChartItem';

import { Flex } from 'components/Flex';

export interface MCSChartProps extends React.HTMLAttributes<HTMLDivElement> {
  valueCount: number;
}

const MCSChart = (props: MCSChartProps) => {
  const { valueCount, ...rest } = props;

  return (
    <Flex gap="xxs" {...rest}>
      {range(0, valueCount).map((index) => (
        <MCSChartItem key={index} index={index} />
      ))}
    </Flex>
  );
};

const MemoizedMCSChart = memo(MCSChart);

export default MemoizedMCSChart;
